module.exports = __webpack_public_path__ + "img/alarm-plus.ccd82074.svg";